import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { Divider } from 'shared/mui/Divider/Divider';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';

import {
  AlertStyled,
  LiStyled,
  OlStyled,
  OlStyledBold,
  UlStyled,
} from './MerchantsShowNotificationsReferenceDialog.styled';

type Props = {
  open: boolean;
  onClose: VoidFunction;
};

export const MerchantsShowNotificationsReferenceDialog: React.FC<Props> = ({ open, onClose }) => {
  const translate = useTypedTranslate();

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <Box>
        <CardHeader
          appendActions={<CloseIconButton key="close-button" onClose={onClose} />}
          sx={{ height: 'auto' }}
          title={translate('app.merchantsShowNotifications.notificationsGuide.title')}
          titleSize="smallBold"
        />
        <CardContent sx={{ overflow: 'auto', maxHeight: 'calc(100vh - 160px)' }}>
          <Typography sx={{ marginBottom: '8px' }} variant="body2">
            {translate('app.merchantsShowNotifications.notificationsGuide.intro')}
          </Typography>
          <OlStyledBold>
            <LiStyled>
              {translate('app.merchantsShowNotifications.notificationsGuide.step1')}
            </LiStyled>
            <LiStyled>
              {translate('app.merchantsShowNotifications.notificationsGuide.step2')}
            </LiStyled>
            <LiStyled>
              {translate('app.merchantsShowNotifications.notificationsGuide.step3')}
            </LiStyled>
            <AlertStyled severity="info">
              <Typography variant="body2">
                {translate('app.merchantsShowNotifications.notificationsGuide.eventsInfo')}
              </Typography>
            </AlertStyled>
            <LiStyled>
              {translate('app.merchantsShowNotifications.notificationsGuide.step4')}
            </LiStyled>
          </OlStyledBold>
          <Divider
            orientation="horizontal"
            sx={{ marginTop: 2, marginBottom: 2, borderColor: 'divider' }}
          />
          <Typography sx={{ fontWeight: 500, marginBottom: '8px' }} variant="body1">
            {translate('app.merchantsShowNotifications.notificationTest.title')}
          </Typography>
          <OlStyled>
            <li>
              {translate('app.merchantsShowNotifications.notificationTest.step1.before')}
              <Typography component="span" sx={{ fontWeight: 500 }} variant="body2">
                {translate('app.merchantsShowNotifications.notificationTest.step1.action')}
              </Typography>
              .
            </li>
            <li>
              {translate('app.merchantsShowNotifications.notificationTest.step2.before')}
              <Typography component="span" sx={{ fontWeight: 500 }} variant="body2">
                {translate('app.merchantsShowNotifications.notificationTest.step2.action')}
              </Typography>
              .
            </li>
            <li>{translate('app.merchantsShowNotifications.notificationTest.step3')}</li>
          </OlStyled>
          <Typography variant="body2">
            {translate('app.merchantsShowNotifications.notificationTest.ifNotReceived')}
          </Typography>
          <UlStyled sx={{ marginLeft: '18px' }}>
            <li>{translate('app.merchantsShowNotifications.notificationTest.fix1')}</li>
            <li>{translate('app.merchantsShowNotifications.notificationTest.fix2')}</li>
          </UlStyled>
          <Typography variant="body2">
            {translate('app.merchantsShowNotifications.notificationTest.conclusion')}
          </Typography>
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={
            <Button
              label={translate('app.merchantsShowNotifications.notificationsGuide.backButton')}
              onClick={onClose}
              variant="outlined"
            />
          }
        />
      </Box>
    </Dialog>
  );
};
